import Marionette from 'backbone.marionette';
import aboutItemviewTmpl from '../templates/about_itemview.tpl';
export default Marionette.ItemView.extend({
  template: aboutItemviewTmpl
});